import { supabase } from '../../lib/supabase';
import { journal, type Action } from '../../engine/actions';
import { runSummary } from '../../engine/score';
import type { GameState } from '../../engine/types';

export type RunRow = {
  id: string; user_id: string; party_name: string; legislatures: number; final_share: number | null; laws: number;
  score: number; difficulty: string; seed: number; verified: boolean; created_at: string; username?: string | null; category?: string;
};

export type SubmitResult = { ok: true; verified: boolean; score: number } | { ok: false; reason: string };

/**
 * Trägt eine beendete Partie in die Bestenliste ein.
 * Erst wird die Edge Function `verify-run` gefragt: sie spielt das Zugprotokoll nach und
 * berechnet die Punkte selbst. Ist sie nicht erreichbar, landet die Partie ungeprüft in der Liste.
 */
export async function submitRun(S: GameState, moves: Action[] = journal): Promise<SubmitResult> {
  if (!supabase) return { ok: false, reason: 'offline' };
  const { data: u } = await supabase.auth.getUser(); if (!u.user) return { ok: false, reason: 'nicht angemeldet' };
  const summary = runSummary(S);

  try {
    const { data, error } = await supabase.functions.invoke('verify-run', { body: { seed: S.seed, journal: moves, claimed: summary.score } });
    if (!error && data && data.ok) return { ok: true, verified: true, score: data.score };
  } catch { /* Funktion nicht deployt oder nicht erreichbar */ }

  // Ohne Bestätigung (Funktion fehlt, oder das Protokoll ließ sich nicht nachspielen, z. B. nach
  // einer Migration des Spielstands) landet die Partie ungeprüft in der Liste.

  const { error } = await supabase.from('runs').insert({ user_id: u.user.id, ...summary, verified: false, journal: moves.length <= 5000 ? moves : null });
  return error ? { ok: false, reason: error.message } : { ok: true, verified: false, score: summary.score };
}

const OLD: Record<number, string> = { 2: 'leicht', 3: 'normal', 4: 'schwer' };
export async function topRuns(limit = 25, onlyVerified = false, category: 'normal' | 'autoritaer' = 'normal', level = 0): Promise<RunRow[]> {
  if (!supabase) return [];
  const base = () => {
    let q = supabase!.from('leaderboard').select('*').order('score', { ascending: false }).limit(limit); if (onlyVerified) q = q.eq('verified', true);
    if (level) q = q.or(`difficulty.like.stufe-${level}%${OLD[level] ? `,difficulty.eq.${OLD[level]}` : ''}`); // Version 12: Erfahrungsstufen, ältere Partien zugeordnet
    return q;
  };
  const { data, error } = await base().eq('category', category);
  if (!error) return (data as RunRow[]) ?? [];
  if (category !== 'normal') return []; // Migration 0012 fehlt: noch keine eigene Kategorie
  const { data: d2 } = await base();
  return (d2 as RunRow[]) ?? [];
}
